module.exports = __webpack_public_path__ + "img/howto_ico07.d758a63a.png";